<template>
  <index-content :breadcrumb-items="breadcrumbItems">
    <template #options>
      <div class="n-button-box">
        <nb-add @on-click="openModal" />
      </div>
    </template>
    <div class="table-responsive">
      <table class="table table-bordered table-hover table-striped text-center n-table">
        <thead>
          <tr>
            <th class="id">{{ $t('label.id') }}</th>
            <th>{{ $t('label.cohortId') }}</th>
            <th v-rw v-table-action>{{ $t('label.action') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in records" :key="row.id">
            <td>{{ row.id }}</td>
            <td>{{ row.cohortId }}</td>
            <td v-rw class="n-button-box">
              <nb-confirm text="remove" @on-ok="doRemove(row)"></nb-confirm>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </index-content>
</template>

<script>
import BaseCompanyView from './view';
import { getSelection } from '@/store';
import ModalCampaignCohort from './ModalCampaignCohort';
import { fetch, remove } from '@/api/company/company-cohort';

export default BaseCompanyView.extend({
  name: 'CompanyCampaignCohort',

  data() {
    return {
      preload: true,
    };
  },

  mounted() {
    this.campaignId = +this.$route.params.campaignId;
    let campaignName = getSelection('company.campaign', this.campaignId);
    this.breadcrumbItems = [campaignName, this.$t(`label.cohorts`)];
  },

  methods: {
    doLoad() {
      let campaignId = this.campaignId;
      return fetch({ campaignId });
    },

    doRemove(o) {
      return remove(o);
    },

    openModal(model = { campaignId: this.campaignId }) {
      this.createModal(ModalCampaignCohort, { model, props: { subName: 'cohort' }, on: this });
    },

    parse(r) {
      this.records = r;
    },
  },
});
</script>

<style lang="scss" scoped>
.n-table {
  th.id {
    width: 8rem;
  }

  th.rw-action {
    width: 5.5rem;
  }

  th.ro-action {
    width: 6rem;
  }
}
</style>
